import { User } from "features/auth";
import { Text } from "atoms";
import { ProfileDiscordOverrides } from "./ProfileDiscordOverrides";

type ProfileDiscordParams = {
  user: User;
  isAdmin?: boolean;
};
function ProfileDiscord({ user, isAdmin = false }: ProfileDiscordParams) {
  return (
    <div>
      <p>
        <Text as="strong" size="xxxs">
          Username
        </Text>
        <br />
        <Text as="strong" size="xxs">
          {user.discord ? user.discord : "Not Connected"}
          {!!user.utilities?.length && ` (${user.utilities.sort().join(", ")})`}
        </Text>
      </p>

      <ProfileDiscordOverrides user={user} />
      {isAdmin && (
        <p>
          <Text as="strong" size="xxxs">
            User Id
          </Text>
          <br />
          <Text as="strong" size="xxs">
            {user.discordId || "Not Connected"}
          </Text>
        </p>
      )}
    </div>
  );
}

export { ProfileDiscord };
